import DataObjectList from '../../../common/model/DataObjectList';

import ContractRange from './ContractRange';

export default class ContractRangeList extends DataObjectList {
  getElementClassType() {
    return ContractRange;
  }
}